'use client';

import { freddyTheme, IconButton } from '@coolblue-development/freddy';
import selectOptionTrigger from '@coolblue-development/ga4-events/triggers/InternalIcons/selectOptionTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ReactElement, ReactNode } from 'react';

export default function PriceTagIconButton({
  url,
  index,
  totalIndices,
  children
}: {
  url: string;
  index: number;
  totalIndices: number;
  children: ReactNode;
}): ReactElement {
  const { trackEvent } = useAnalytics();

  return (
    <IconButton
      component='a'
      href={url}
      size='small'
      target='_blank'
      onClick={() => {
        trackEvent(
          selectOptionTrigger({
            sub_feature: 'store_product_tag',
            index: index,
            total_indices: totalIndices,
            selection_type: 'selected',
            option_name: 'price_tag',
            attribute: 'price_tag'
          })
        );
      }}
      sx={{
        padding: freddyTheme.spacing[200],

        svg: {
          width: '2rem',
          height: '2rem'
        }
      }}
    >
      {children}
    </IconButton>
  );
}
